import { useCallback, useState } from 'react';

type PreviewInputType = File | string | null | undefined;

export default function usePreviewImage(input?: PreviewInputType) {
  const [base64Data, setBase64Data] = useState<string>(() => {
    if (!input) return '';
    if (input instanceof File) return URL.createObjectURL(input);

    return input;
  });

  const previewImage = useCallback((input: PreviewInputType) => {
    if (!input) {
      setBase64Data('');
    } else if (input instanceof File) {
      setBase64Data(URL.createObjectURL(input));
    } else {
      setBase64Data(input);
    }
  }, []);

  return [base64Data, previewImage] as const;
}
